// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1ht2X","field":"styles_field__WwJKi","fieldCol":"styles_fieldCol__1FTeW","diffCol":"styles_diffCol__qgUQH","diff":"styles_diff__P1gaC"};